import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import optionTypes from '../constants/option-types';
import ElementSettingsContext from '../helpers/element-settings-context';
import { getOptionFlatAttributesValues } from '../helpers/get-option-attributes-values';

const { ToggleSection, Box } = designSystem;

function ToggleOption({ option, settingId, onUpdateValue }) {
  const { state, callbacks } = useContext(ElementSettingsContext);

  const flattenedAttributesValues = getOptionFlatAttributesValues(state, option);
  const isToggleEnabled = flattenedAttributesValues.every((value) => value !== false);

  const paddingProps = {
    paddingTop: 'spacing-xs',
    paddingBottom: 'spacing-xs',
    paddingLeft: 'spacing-m',
    paddingRight: 'spacing-m',
  };

  const handleToggleChange = (newValue) => {
    onUpdateValue(newValue);
    callbacks.onOptionClicked({ optionId: option.id, settingId });
  };

  return (
    <Box {...paddingProps}>
      <ToggleSection
        value={isToggleEnabled}
        title={option.title}
        {...(option.popover && { popoverProps: option.popover })}
        onChange={handleToggleChange}
      />
    </Box>
  );
}

ToggleOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: optionTypes.TOGGLE.isRequired,
    elementIds: PropTypes.arrayOf(PropTypes.string),
    attributes: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    popover: PropTypes.shape({
      title: PropTypes.string.isRequired,
      imgSrc: PropTypes.string,
    }),
    computeFallbackValue: PropTypes.func,
  }).isRequired,
  settingId: PropTypes.string.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
};

export default ToggleOption;
